///<reference path="../common/smart-mover.models.ts"/>
///<reference path="../../../../plugins/reports/reports.models.ts"/>
///<reference path="../common/collection-category.ts"/>


module Meevo.Components.Controls.SmartMover {


    import DP005ProductCategory = Meevo.Plugins.Reports.DP005ProductCategory;
    import DP005ProductManufecturer = Meevo.Plugins.Reports.DP005ProductManufecturer;
    import IReportManufacturers = Meevo.Plugins.Reports.IReportManufacturers;

    export class ProductCatToManufacturersStrategy implements ICollectionPopulate {
        constructor(
            private manufacturers: ICollectionBase<DP005ProductManufecturer>,
            private productCategories: ICollectionBase<DP005ProductCategory>) {
        }

        populate(): void {
            if (this.manufacturers.models.length === 0) {
                return;
            }

            for (const manufacturer of this.manufacturers.models) {
                (<ISmartMoverCategoryModel<IReportManufacturers>>manufacturer).resetModels(
                    this.productCategories.models.filter(category => manufacturer.id === category.get('manufacturer_TId'))
                );
            }
        }
    }
}